import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  AnimotoAppLogoGraphic,
  Button,
  BodySmall,
  buttonSizes,
  buttonTypes,
  HeaderExtraSmall,
  surfaceColors
} from '@animoto/components/lib/es/design-system';
import { trackFeatureUsage } from '@animoto/utils/analytics';

import {
  container,
  desktop,
  logo,
  text,
  textWrapper
} from './Banner.module.css';

// TODO: rename to Banner if test is successful
export default function Banner({
  hasVideoCompleted,
  isIOS,
  isMobile,
  onClick
}) {
  const wrapperClasses = classNames(container, {
    [desktop] : !isMobile
  });
  const mobileText = isIOS ? 'Make videos in minutes' : 'Make your own video in minutes';
  const mobileButtonText = isIOS ? 'Get app' : 'Start free';
  const trackClick = () => {
    trackFeatureUsage({
      scope   : 'visitor-play-page',
      feature : 'banner',
      action  : 'click'
    });
  };

  const onClickButton = () => {
    trackClick();
    onClick();
  };
  return (
    <div className={wrapperClasses}>
      {isMobile ? (
        <>
          {isIOS && (
            <div className={logo}>
              <AnimotoAppLogoGraphic />
            </div>
          )}
          <div className={textWrapper}>
            <HeaderExtraSmall isInverted>Animoto</HeaderExtraSmall>
            <BodySmall isInverted>{mobileText}</BodySmall>
          </div>
          <Button
            href={isIOS ? '/builder-mobile' : '#'}
            onClick={isIOS ? trackClick : onClickButton}
            size={buttonSizes.SMALL}
            surfaceColor={surfaceColors.ACCENT}
            type={hasVideoCompleted ? buttonTypes.PRIMARY : buttonTypes.SECONDARY}
          >
            {mobileButtonText}
          </Button>
        </>
      ) : (
        <>
          <HeaderExtraSmall className={text} isInverted>Create a video in minutes with Animoto.<br /> No credit card required. </HeaderExtraSmall>
          <Button
            onClick={onClickButton}
            size={buttonSizes.SMALL}
            surfaceColor={surfaceColors.ACCENT}
            type={hasVideoCompleted ? buttonTypes.PRIMARY : buttonTypes.SECONDARY}
          >
            Get started free
          </Button>
        </>
      )}
    </div>
  );
}

Banner.propTypes = {
  hasVideoCompleted : PropTypes.bool.isRequired,
  isIOS             : PropTypes.bool.isRequired,
  isMobile          : PropTypes.bool.isRequired,
  onClick           : PropTypes.func.isRequired
};
